import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  appoinment: {
    isVisible: false,
  },
  addCard: {
    isVisible: false,
  },
  checkout: {
    isVisible: false,
  },
  indications: {
    isVisible: false,
  },
  schedule: {
    isVisible: false,
  },
  paymentSubscription: {
    isVisible: false,
  },
  nutritionistAppointment: {
    isVisible: false,
  },
  appointmentConfirmation: {
    isVisible: false,
  },
};

export const drawersSlice = createSlice({
  name: 'drawers',
  initialState,
  reducers: {
    setVisibility: (state, action) => {
      state[action.payload.key].isVisible = action.payload.status;
    },
  },
});

export const { setVisibility } = drawersSlice.actions;

export const drawersReducer = drawersSlice.reducer;
